/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_SkillsInputs */

const en_tut_sc_skills = /** @type {(inputs: Tut_Sc_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Skills`)
};

const id_tut_sc_skills = /** @type {(inputs: Tut_Sc_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Skill`)
};

/**
* | output |
* | --- |
* | "Jump to Skills" |
*
* @param {Tut_Sc_SkillsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_skills = /** @type {((inputs?: Tut_Sc_SkillsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_SkillsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_skills(inputs)
	return en_tut_sc_skills(inputs)
});